import React from 'react'

function SalesIcon({ className, ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6 7.75H18C19.2426 7.75 20.25 8.75736 20.25 10V17C20.25 18.2426 19.2426 19.25 18 19.25H6C4.75736 19.25 3.75 18.2426 3.75 17V10C3.75 8.75736 4.75736 7.75 6 7.75Z"
        stroke="#899CBD"
        strokeWidth="1.5"
      />
      <path
        d="M15 7V6C15 4.89543 14.1046 4 13 4H11C9.89543 4 9 4.89543 9 6V7"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 11L5.0798 12.1152C9.22853 15.0437 14.7715 15.0437 18.9202 12.1152L20.5 11"
        stroke="#899CBD"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default SalesIcon